import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './optOutConfirmation.actions';
import OptOutConfirmationModal from './optOutConfirmationModal';


const mapStateToProps = function (state) {
  return {
    visible: state.optOutConfirmationModal.visible,
    formInstance: state.optOutConfirmationModal.formInstance
  };
};

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({...actions}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(OptOutConfirmationModal);
